const DROPDOWN = {
    onReady() {
        document.addEventListener('click', DROPDOWN.toggle); 
    },
    /*********************
    * Must be handled over a document event listener because of xhr reloads
    *********************/
    toggle(event) {
        let dropdown = event.target.closest('.dropdown');
        if (dropdown !== null) {
            dropdown.classList.toggle('active');
        } else {
            let dropdowns = document.querySelectorAll('.dropdown.active');
            dropdowns.forEach(dropdown => {
                dropdown.classList.remove('active');
            });
        }
    }
}